import { Component, forwardRef } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap/datepicker/ngb-date";
import * as moment from "moment";
import { NgbCustomParserFormatter } from "../date-picker/ngb-custom-parser-formatter";
import { NgbMonthDayYearFormatParser } from "./ngb-month-day-year-format-parser";

@Component({
  selector: "typeable-date-picker",
  templateUrl: "typeable-date-picker.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TypeableDatePickerComponent),
      multi: true,
    },
    {
      provide: NgbMonthDayYearFormatParser,
      useClass: NgbCustomParserFormatter,
    },
  ],
})
export class TypeableDatePickerComponent implements ControlValueAccessor {
  model: NgbDateStruct;
  onChange = (newDate: string) => {};
  onTouched = () => {};

  constructor() {}

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {}

  writeValue(obj: any): void {
    if (!obj) {
      return;
    }

    const momentValue = moment.utc(obj);
    this.model = new NgbDate(
      momentValue.year(),
      momentValue.month() - 1,
      momentValue.date()
    );
  }

  textChanged($event: any): void {
    if ($event && $event.year && $event.month && $event.day) {
      this.model = $event;
      this.onChange(
        moment.utc(new Date($event.year, $event.month - 1, $event.day)).format()
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/typeable-date-picker/typeable-date-picker.ts